<template>
  <layout-auth
    message="Welcome Back!"
    :center-vertically="!accountIsCanceled"
    :show-register-link="!accountIsCanceled"
  >
    <!-- Show Login Form -->
    <form v-if="accountStatus === null" @submit.prevent="login">
      <!-- Email -->
      <form-field-input
        label="Email"
        v-model="loginForm.email_address"
        :validation-errors="validationErrors.email_address"
        size=""
        type="email"
        v-autofocus
      ></form-field-input>

      <!-- Password -->
      <form-field-password
        label="Password"
        v-model="loginForm.password"
        :validation-errors="validationErrors.password"
        size=""
      ></form-field-password>
      <p class="py-0 help has-text-right">
        <router-link :to="{name: 'password-request'}">Forgot Password?</router-link>
      </p>

      <button-default
        class="auth_button"
        :disabled="isLoggingIn"
        :loading="isLoggingIn"
        size=""
        type="submit"
      >
        Login
      </button-default>
    </form>

    <template v-if="accountIsCanceled">
      <!-- Email -->
      <form-field-input
        label="Email"
        disabled
        v-model="reactivationForm.email_address"
        :validation-errors="validationErrors.email_address"
        size=""
        type="email"
        v-autofocus
      ></form-field-input>

      <!-- Password -->
      <form-field-password
        label="Password"
        disabled
        v-model="reactivationForm.password"
        :validation-errors="validationErrors.password"
        size=""
      ></form-field-password>

      <!-- User is an owner-->
      <!-- User is not an owner-->
      <template v-if="!userIsOwner">
        <p class="login-message">Your account is cancelled, have an owner of the account login and reactivate the account.</p>
      </template>
      <template v-else>
        <p class="login-message mb-100">
          <template v-if="reactivationForm.clean_up_at">
            Your account is currently canceled. Reactivate it any time before {{ cleanUpAt }}, and all of your data will be as it was. After {{ cleanUpAt }} we will delete all information tied to the account and your data will not be recoverable.
          </template>
          <template v-else>
            Your account is currently canceled. Reactivate it now, and all of your data will be as it was.
          </template>
        </p>

        <div>
          <button-outlined
            @click="customerPortal"
            is-short
            :loading="isOpeningBillingPortal"
          >
            Reactivate Account
          </button-outlined>
        </div>
      </template>
    </template>

    <template v-if="accountIsPaused">
      <!-- Email -->
      <form-field-input
        label="Email"
        disabled
        v-model="reactivationForm.email_address"
        :validation-errors="validationErrors.email_address"
        size=""
        type="email"
        v-autofocus
      ></form-field-input>

      <!-- Password -->
      <form-field-password
        label="Password"
        disabled
        v-model="reactivationForm.password"
        :validation-errors="validationErrors.password"
        size=""
      ></form-field-password>

      <!-- User is an owner-->
      <template v-if="!userIsOwner">
        <p class="login-message">Your account is paused, have an owner of the account login and reactivate the account.</p>
      </template>
      <template v-else>
        <p class="login-message mb-100">
          <template v-if="reactivationForm.clean_up_at">
            Your account is currently paused. Resume it any time before {{ cleanUpAt }}, and all of your data will be as it was. After {{ cleanUpAt }} we will delete all information tied to the account and your data will not be recoverable.
          </template>
          <template v-else>
            Your account is currently paused. Resume it now, and all of your data will be as it was.
          </template>
        </p>

        <div>
<!--          <button-outlined-->
<!--            @click="billingPortal"-->
<!--            is-short-->
<!--            :loading="isOpeningBillingPortal"-->
<!--          >-->
<!--            Visit Billing Portal-->
<!--          </button-outlined>-->
          <button-outlined
            @click="resumeSubscription"
            is-short
            :loading="isResuming"
          >
            Resume Subscription
          </button-outlined>
        </div>
      </template>
    </template>
  </layout-auth>
</template>

<script>
import auth from "../../api/auth";
import {ENUMS} from "../../services/enums";
import LocalStorage from "../../services/localStorage";
import dates from "../../services/dates";
import axios from "axios";
import router from "../../router";
import api from "../../api";
import {SnackbarProgrammatic as Snackbar} from 'buefy';

export default {
  name: "LoginPage",
  metaInfo: {
    title: "Login"
  },
  data() {
    return {
      hasCookie: false,
      isLoggingIn: false,
      isOpeningBillingPortal: false,
      isResuming: false,
      loginForm: {
        email_address: null,
        password: null,
      },
      validationErrors: {},
      accountStatus: null,
      userIsOwner: false,
      reactivationForm: {
        clean_up_at: null,

        street_address: null,
        city: null,
        state: null,
        postcode: null,
      }
    };
  },
  beforeCreate() {
    axios.get('/sanctum/csrf-cookie').then(response => {
      // Login...
      this.hasCookie = true;
    });
  },
  computed: {
    accountIsPaused() {
      return this.accountStatus === ENUMS.AccountStatusEnum.Paused.value;
    },
    accountIsCanceled() {
      return this.accountStatus === ENUMS.AccountStatusEnum.Canceled.value;
    },
    cleanUpAt() {
      if(!this.reactivationForm) return '';
      return dates.formatAsDate(this.reactivationForm.clean_up_at)
    }
  },
  methods: {
    login() {
      this.isLoggingIn = true;

      auth.login(this.loginForm).then((res) => {
        if (res.data.account.status === ENUMS.AccountStatusEnum.Provisioning.value) {
          router.push({name: 'account-provisioning'})
          return
        }
        console.log('res', res)

        router.push('/');
      }, (error) => {
        console.log('error', error)
        if (error.response.status === 402) {
          console.log("Error: ", error.response);
          this.accountStatus = error.response.data.status;
          this.validationErrors = {};
          this.userIsOwner = true;
          this.reactivationForm = {
            ...this.loginForm,
            ...error.response.data,
          };

          const data = error.response.data;
        }

        if (error.response.status === 409) {
          this.userIsOwner = false;
          this.validationErrors = {};
          this.accountStatus = error.response.data.status;
          this.reactivationForm = {
            ...this.loginForm,
            ...error.response.data,
          };
        }

        if (error.response.status === 307) {
          router.push({name: 'account-setup', query: {email: this.loginForm.email_address}})
        }

        if (error.response.status === 422) this.validationErrors = error.response.data.errors;

        this.isLoggingIn = false;
      });
    },
    // billingPortal() {
    //   if (! this.userIsOwner) {
    //     Snackbar.open({
    //       message: 'Only owner of the account must reactivate it',
    //       type: 'is-warning',
    //       position: 'is-bottom',
    //       indefinite: true
    //     });
    //     return;
    //   }
    //
    //   this.isOpeningBillingPortal = true
    //   return api.auth.billingPortalSession(this.loginForm.email_address, this.loginForm.password)
    //     .then((res) => {
    //       window.open(res.data)
    //     })
    //     .finally(() => { this.isOpeningBillingPortal = false });
    // },
    resumeSubscription() {
      if (! this.userIsOwner) {
        Snackbar.open({
          message: 'Only owner of the account can resume it',
          type: 'is-warning',
          position: 'is-bottom',
          indefinite: true
        })
        return
      }

      this.isResuming = true
      return api.cancelAccount.resumeAccount(this.loginForm)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Success! Logging in...',
            type: 'is-success'
          })

          // start login process
          this.login()
        })
        .catch((error) => {
          this.isResuming = false
        })
    },
    customerPortal() {
      if (! this.userIsOwner) {
        Snackbar.open({
          message: 'Only owner of the account must reactivate it',
          type: 'is-warning',
          position: 'is-bottom',
          indefinite: true
        });
        return;
      }

      this.isOpeningBillingPortal = true
      return api.auth.customerPortalSession(this.loginForm.email_address, this.loginForm.password)
        .then((res) => {
          window.open(res.data.data.url)
        })
        .finally(() => { this.isOpeningBillingPortal = false });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.form_section {
  max-width: 480px;
  margin: 0 auto 30px;
  padding: 0 5% 30px;
  border-bottom: 1px solid $border;

  &.last {
    border-bottom: 0;
  }
}

.login-message {
  line-height: 1.2;
}

.button_section {
  max-width: 480px;
  margin: -20px auto 20px;
  padding: 0 5%;
}

.plan_name {
  font-weight: bold;
  font-size: 1.25rem;
}

.plan_savings {
  font-size: 0.875rem;
  color: $primary;
  font-style: italic;
}

.cost_line {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-left: 14px;
}

.total_line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0 30px;

  &--label {
    font-size: 1.25rem;
  }

  &--value {
    font-size: 1.25rem;
    color: $secondary;
    font-weight: bold;
  }
}

.disclaimer_text {
  color: $text-muted;
  font-size: 0.875rem;
  line-height: 1.2;
}

.creating_text {
  margin-top: 14px;
  text-align: center;
  font-style: italic;
}

.invalid_heading {
  margin-bottom: 12px;
  font-size: 1.375rem;
  font-weight: bold;
}

.invalid_text {
  line-height: 1.4;
}
</style>
